<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-10 15:37:48
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-26 20:12:55
-->
<template>
	<el-drawer title="新增规格" :visible.sync="drawer" :append-to-body="true" class="apply-sample-drawer" :before-close="handleClose" size="724px">
		<!-- 搜索框部分 -->
		<div class="pos-rela flex-row-align-center">
			<div class="custom flex-1 font-h6-regular yx-color-text-primary">
				<input type="text" ref="input" v-model="textValue" class="search-input" placeholder="请输入规格名称" />
			</div>
			<el-button class="searchBtn" @click="search">搜索</el-button>
		</div>

		<!-- 列表部分 -->
		<div class="table mt-24" v-loading="loading">
			<el-table
				class="table-small"
				header-row-class-name="table-header-row"
				row-class-name="table-row"
				:data="tableData"
				ref="multipleTable"
				@selection-change="handleSelectionChange"
				row-key="id"
			>
				<el-table-column
					type="selection"
					min-width="55"
					:reserve-selection="true"
					:selectable="({ skuId }) => !hasSelectedSku.includes(skuId)"
				></el-table-column>
				<el-table-column label="商品规格" min-width="265">
					<template slot-scope="{ row }">
						<div class="flex-row-align-center">
							<el-image style="width: 40px; height: 40px; border-radius: 2px" :src="row.imageUrl">
								<template v-slot:error>
									<img src="@/assets/public/img-empty1.png" alt="" />
								</template>
							</el-image>
							<Explain :content="row.specification" :showIcon="false" :disabled="row.specification.length <= 16">
								<el-tag type="info" effect="plain" size="small" class="ml-28">{{ row.specification | textFormat(16) }}</el-tag>
							</Explain>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="livePrice" label="直播价" min-width="80">
					<template slot-scope="{ row }">
						<div class="font-h6-regular yx-color-text-primary">{{ row.price | formatPrice }}</div>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 底部按钮部分 -->
		<div class="bott">
			<div>
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" :disabled="isDisable" @click="add">确认添加</el-button>
			</div>
		</div>
	</el-drawer>
</template>
<script>
import { getProductSkuListOne } from '@/api/shopManage';
export default {
	props: {
		platformId: {
			type: [Number, String],
			default: dataMap.PLATFORM_DY.value,
		},
	},
	data() {
		return {
			selectionList: [],
			drawer: false,
			tableData: [],
			textValue: '',
			loading: false,
			productId: '',
			hasSelectedSku: [],
		};
	},
	computed: {
		isDisable({ selectionList }) {
			return !selectionList.length;
		},
	},
	methods: {
		async show(productId, disabledList = []) {
			if (!productId) {
				return;
			}
			this.hasSelectedSku = disabledList.map(item => item.skuId);
			this.productId = productId;
			this.getSkuList({ productId: productId });
			this.drawer = true;
		},
		handleSelectionChange(val) {
			this.selectionList = val;
		},
		handleClose() {
			this.tableData = [];
			this.selectionList = [];
			this.textValue = '';
			this.hasSelectedSku = [];
			this.$refs.multipleTable.clearSelection();
			this.drawer = false;
		},
		add() {
			this.$emit('handleAddSku', this.selectionList);
			this.$message.success('添加成功');
			this.handleClose();
		},
		async search() {
			this.getSkuList({ productId: this.productId, skuName: this.textValue });
		},
		async getSkuList(params) {
			this.loading = true;
			const list = await getProductSkuListOne({ ...params, platformId: this.platformId });
			this.tableData = list;
			this.loading = false;
		},
	},
	components: {
		Explain: () => import('@/components/common/explain'),
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-drawer__body {
	padding: 24px !important;
	padding-bottom: 64px !important;
}
.pos-rela {
	.custom {
		border: 1px solid #e0e0e0;
		padding: 4px 12px 0px 12px;
		border-right: none;
		overflow-y: hidden;
		&::-webkit-scrollbar {
			display: none;
		}
		.search-tag {
			.el-tag {
				margin-bottom: 4px;
			}
			.el-tag + .el-tag {
				margin-left: 10px;
			}
		}
		input::placeholder {
			color: #86909d;
		}
		.search-input {
			margin-bottom: 4px;
			width: 200px;
			line-height: 24px;
			height: 24px;
			font-size: 13px;
			caret-color: @color-primary;
		}
	}
	.searchBtn {
		width: 72px;
		background-color: @color-primary;
		color: @color-white;
		font-size: 13px;
		border-radius: 2px;
		height: 34px;
	}
}
.bott {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	z-index: 2000;
}
</style>
